import { MediaFile } from "../../types/media";

export const GET_MEDIA_REQUEST = "GET_MEDIA_REQUEST";
export const GET_MEDIA_REQUEST_SUCCESS = "GET_MEDIA_REQUEST_SUCCESS";
export const GET_MEDIA_REQUEST_ERROR = "GET_MEDIA_REQUEST_ERROR";

export interface GetMediaRequest {
  type: typeof GET_MEDIA_REQUEST;
  payload: number;
}

export interface GetMediaRequestSuccess {
  type: typeof GET_MEDIA_REQUEST_SUCCESS;
  payload: MediaFile;
}

export interface GetMediaRequestError {
  type: typeof GET_MEDIA_REQUEST_ERROR;
  payload: any;
}

export interface State {
  data: any;
  states: {
    success: boolean;
    loading: boolean;
    error: string | boolean;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetMediaRequest | GetMediaRequestSuccess | GetMediaRequestError;
